interface MetricCardProps {
  label: string;
  value: string | number;
  sub?: string;
  accent?: string;
}

export function MetricCard({ label, value, sub, accent = 'text-white' }: MetricCardProps) {
  return (
    <div className="card-compact">
      <div className="text-[11px] text-gray-500 font-medium uppercase tracking-wide mb-1">
        {label}
      </div>
      <div className={`text-2xl font-bold ${accent}`}>{value}</div>
      {sub && <div className="text-[11px] text-gray-500 mt-1">{sub}</div>}
    </div>
  );
}
